import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const LoadingSpinner = ({ size = 'default', className, ...props }) => {
  const sizes = {
    sm: { dot: 'w-2 h-2', gap: 'gap-1' },
    default: { dot: 'w-3 h-3', gap: 'gap-1.5' },
    lg: { dot: 'w-4 h-4', gap: 'gap-2' },
    xl: { dot: 'w-5 h-5', gap: 'gap-2.5' }
  };

  const dotVariants = {
    initial: { scale: 0.8, opacity: 0.5 },
    animate: { scale: 1.2, opacity: 1 },
  };

  return (
    <motion.div
      className={cn('flex items-center justify-center', className)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      {...props}
    >
      <div className={cn('flex items-center', sizes[size].gap)}>
        {[0, 1, 2].map((index) => (
          <motion.div
            key={index}
            className={cn(
              'rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500',
              sizes[size].dot
            )}
            variants={dotVariants}
            initial="initial"
            animate="animate"
            transition={{
              duration: 0.6,
              repeat: Infinity,
              repeatType: 'reverse',
              delay: index * 0.2,
              ease: 'easeInOut'
            }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export { LoadingSpinner };